import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

export const redirectPartnerRegistrationToken: CanActivateFn = route => {
  if (!route.queryParamMap.get('registration_token')?.trim()) {
    return true;
  }

  return inject(Router).createUrlTree(['/auth/sign-up/partner-registration'], {
    queryParams: route.queryParams
  });
};
